/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledContainer = styled.div`
	h2 {
		text-align: center;
	}
	width: 60%;
	margin: auto;
	padding: 32px;
	@media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
		width: 40%;
	}
	@media (max-width: ${({ theme }) => theme.breakpoints.md}) {
		width: 100%;
	}
`;
export const StyledError = styled.p`
	color: ${({ theme }) => theme.colors.error};
`;
export const StyledBlock = styled.span`
	width: 100%;
	display: inline-block;
	position: relative;
	text-align: center;
`;
export const StyledSucess = styled.p`
	color: ${({ theme }) => theme.colors.success};
	text-align: center;
	width: 100%;
`;
export const StyledBlockComment = styled.div`
	position: absolute;
	margin-top: 100px;
	font-size: 12px;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;
export const StyledBlockModal = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	.react-datepicker__month-container {
		float: left;
	}
`;

export const StyledBlockDateDeb = styled.div`
	.react-datepicker__input-container {
		display: block;
	}
	.date_debut:not(:last-child) {
		margin-bottom: 0px;
	}
	.react-datepicker__time-container
		.react-datepicker__time
		.react-datepicker__time-box
		ul.react-datepicker__time-list
		li.react-datepicker__time-list-item {
		height: 40px;
		padding: 12px 10px;
		white-space: nowrap;
	}
`;

export const StyledDate = styled.div`
	width: 100%;
	.react-datepicker-wrapper {
		display: flex;
	}
	.selected_date:not(:last-child) {
		margin-bottom: 0px;
	}
`;

export const StyledLabelDateDeb = styled.div``;

export const StyledLabelDateFin = styled.div`
	float: left;
	margin-left: -60px;
	margin-top: 15px;
	font-size: 13px;
`;

export const StyledBlockDateFin = styled.div`
	.react-datepicker__input-container {
		display: block;
	}
	.date_fin:not(:last-child) {
		margin-bottom: 0px;
	}
	.react-datepicker__time-container
		.react-datepicker__time
		.react-datepicker__time-box
		ul.react-datepicker__time-list
		li.react-datepicker__time-list-item {
		height: 40px;
		padding: 12px 10px;
		white-space: nowrap;
	}
`;

export const StyledBlockErreurIndispo = styled.div`
	margin-top: 30px;
	font-size: 12px;
`;

export const StyledBlockIconComment = styled.span`
	position: absolute;
	right: 28px;
	top: 14px;
`;
export const StyledCheckboxBlock = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	margin: 25px 0 20px 0;
	& > div {
		margin-right: 10px;
	}
	&:last-of-type {
		margin-bottom: 0;
	}

	@media screen and (max-width: 768px) {
		flex-wrap: wrap;
		justify-content: center;
	}
`;

export const StyledEndTitle = styled.div`
	font-size: 14px;
	margin-bottom: 5px;
	color: ${({ theme }) => theme.colors.text};
	float: left;
	margin-left: -85%;
`;

export const DatePickerContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 200px;

	.react-datepicker-wrapper {
		width: 100%;
	}

	.react-datepicker {
		border: none;

		font-size: 14px;
		background-color: #ffffff;
		border-radius: 5px;
		box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);

		.react-datepicker__current-month {
			color: ${({ theme }) => theme.colors.secondary};
		}

		.react-datepicker__week-number {
			color: ${({ theme }) => theme.colors.secondary};
		}

		&--selected {
			background-color: ${({ theme }) => theme.colors.primaryLight};
			color: #ffffff;
		}

		&:hover {
			background-color: #f6f6f6;
		}

		&--disabled {
			color: #d8d8d8;
		}
	}
`;

export const StyledDateContainer = styled.div`
	.react-datepicker__time-container {
		width: 100%;
	}
	.react-datepicker-wrapper {
		width: 100%;
	}
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
`;

export const StyledDateRow = styled.div`
	width: 100%;
	padding-bottom: 6px;
	padding-top: 10px;
	color: ${({ theme }) => theme.colors.muted};
`;

export const StyledArrow = styled.div`
	display: none;
	margin: 0 10px;
	display: block;
`;

export const CustomButton = styled.button`
	padding: 10px 20px;
	width: 100%;
	border: 1px solid #ccc;
	border-radius: 5px;
	background-color: #ffffff;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
	&:hover {
		background-color: #f0f0f0;
	}
`;
